import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const MoreIcon: FC<SvgProps> = (props) => {
    return (
        <Svg viewBox="0 0 24 24" {...props}>
            <Path d="M12 20c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 10 18c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 12 16c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413s-.196 1.021-.587 1.413A1.928 1.928 0 0 1 12 20Zm0-6c-.55 0-1.02-.196-1.412-.588A1.923 1.923 0 0 1 10 12c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 12 10c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413s-.196 1.02-.587 1.412A1.927 1.927 0 0 1 12 14Zm0-6c-.55 0-1.02-.196-1.412-.588A1.923 1.923 0 0 1 10 6c0-.55.196-1.02.588-1.412A1.923 1.923 0 0 1 12 4c.55 0 1.021.196 1.413.588.391.391.587.862.587 1.412 0 .55-.196 1.02-.587 1.412A1.927 1.927 0 0 1 12 8Z" />
        </Svg>
    )
}

export default MoreIcon
